import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { BasicInfoService } from '../../onboarding-page/basic-info/basic-info.service';
import { ToastMessage } from '../../toast-message/toast-message.service';
import { HelperService } from '../../helper.service';
import { ImageDialogComponent } from '../../image-dialog/image-dialog.component';
import { MatDialog } from '@angular/material';
import { PopUpMessageComponent } from '../../pop-up-message/pop-up-message.component';
import { MatPaginator, PageEvent } from '@angular/material/paginator';


@Component({
  selector: 'app-vehicle-fleet',
  template: require('./vehicle-fleet.component.html'),
  providers: [ToastMessage, BasicInfoService]
})
export class VehicleFleetComponent implements OnInit {

  @ViewChild(MatPaginator) paginator: MatPaginator;

  public mobile: any;
  public number: any;
  public fleetId: any;
  public mode: any;
  public modeId: any;
  overHeadPanelTitle = 'Fleet Vehicle Data'
  public recordsPerPage = 10;
  public pageSizeOptions = [this.recordsPerPage];
  public currentPage = 0;
  public riderLogData: any;
  public userMapping = {};
  public filter = {};
  public typeMapping = {
    'basic-info' : 'Basic Info',
    'profile-picture': 'Profile Picture',
    'drivers-license': 'Driving License',
    'registration-card': 'Registration Card',
    'more-info': 'More Info',
    'image-view': 'Image View',
    'loyalty': 'Loyalty',
    'services': 'Services',
    'pan': 'Pan',
    'aadhar': 'Aadhaar',
    'shift-update': `Shift Update`,
  };
  public vehiclesList: any;

  public docView = ['imageToUpload', 'ppDetails', 'dlData', 'rcDetails'];
  public dlApproveKeys = ['remarks', 'number'];
  public rcApprovalKeys = ['vehicleNumber', 'make'];
  public columnsToDisplay: any;
  public dataSource: any;
  public totalRecords: any;
  public selectedFilter: any;
  public filterItems = ['Activation', 'Deactivation', 'Suspension'];
  public targetRides;
  public campaignDuration = 0;
  public cashBackAmount;

  // UI state
  public searchTerm = '';
  public selectedNumbers: Set<string> = new Set();
  public isRemoving = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private spinnerService: Ng4LoadingSpinnerService,
    private basicInfoService: BasicInfoService,
    private toastMessage: ToastMessage,
    private helperService: HelperService,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    this.mobile = this.route.snapshot.queryParamMap.get('mobile');
    this.number = this.route.snapshot.queryParamMap.get('number');
    this.fleetId = this.route.snapshot.queryParamMap.get('fleetId');
    this.mode = this.route.snapshot.queryParamMap.get('mode');
    this.modeId = this.route.snapshot.queryParamMap.get('modeId');
    this.fetchFleetVehicles();
  }

  goBack() {
    this.router.navigate(['/searchFleet']);
  }
  fetchFleetVehicles() {
    this.spinnerService.show();
    this.basicInfoService.getFleetVehicleData(
      this.mobile, this.number, this.recordsPerPage, this.currentPage*this.recordsPerPage,
    ).subscribe( res => {
      this.riderLogData = res;
      this.spinnerService.hide();
      this.getFleetVehicleInfo();
    },
    error => {
      this.spinnerService.hide();
      const errorMessage = error.error && error.error.message ? error.error.message : 'Could not fetch rider logs';
      this.toastMessage.openSnackBarError(errorMessage);
    });
    return this.riderLogData;
  }

  getFleetVehicleInfo() {
    const totalRecords = this.riderLogData.totalDocuments || 0;

    const riderLogColumns = [
      'Select', 'Number', 'Status'
    ];
    this.viewRiderLogs(this.riderLogData.data, riderLogColumns, totalRecords);
  }

  pageChanged(pageInfo) {
    this.recordsPerPage = pageInfo.pageSize;
    this.currentPage = pageInfo.pageIndex;
    this.fetchFleetVehicles();
  }

  viewRiderLogs(riderLogs, riderLogColumns, totalRecords) {
    this.vehiclesList = [];
    this.vehiclesList = riderLogs;
    this.dataSource = this.vehiclesList;
    this.dataSource.paginator = this.paginator;
    this.columnsToDisplay = riderLogColumns;
    this.totalRecords = totalRecords;
  }
  displayVehicle(row: any){
    this.router.navigate(
      ['/onboarding'],
      { queryParams: { fleetId: this.fleetId, mode: this.mode, number: row.number, modeId: this.modeId}}
    );
  }

  // Search and selection helpers
  onSearch(term: string) {
    this.searchTerm = term || '';
    // If comma-separated list, call server to fetch matching vehicles
    const parts = (this.searchTerm || '').split(',').map(v => v.trim()).filter(v => !!v);
    if (parts.length > 10) {
      this.toastMessage.openSnackBarError('Please enter at most 10 vehicle numbers');
      return;
    }
    const csv = parts.join(',');
    // When empty, just refetch the default list (no numbers filter)
    this.spinnerService.show();
    this.basicInfoService.getFleetVehicleDataByNumbers(this.mobile, csv || '', this.recordsPerPage, this.currentPage*this.recordsPerPage)
      .subscribe(res => {
        this.riderLogData = res;
        this.spinnerService.hide();
        this.getFleetVehicleInfo();
      }, error => {
        this.spinnerService.hide();
        const errorMessage = error && error.error && error.error.message || 'Could not fetch rider logs';
        this.toastMessage.openSnackBarError(errorMessage);
      });
  }

  isSelected(row: any): boolean {
    return this.selectedNumbers.has(row.number);
  }

  toggleSelection(row: any, checked: boolean) {
    if (!row) { return; }
    if (checked) {
      this.selectedNumbers.add(row.number);
    } else {
      this.selectedNumbers.delete(row.number);
    }
  }

  isAllSelected(): boolean {
    if (!this.vehiclesList || this.vehiclesList.length === 0) { return false; }
    return this.vehiclesList.every(v => this.selectedNumbers.has(v.number));
  }

  toggleSelectAll(checked: boolean) {
    if (!this.vehiclesList) { return; }
    if (checked) {
      this.vehiclesList.forEach(v => this.selectedNumbers.add(v.number));
    } else {
      this.vehiclesList.forEach(v => this.selectedNumbers.delete(v.number));
    }
  }

  removeSelectedVehicles() {
    const numbers = Array.from(this.selectedNumbers);
    if (numbers.length === 0) {
      this.toastMessage.openSnackBarError('Please select at least one vehicle');
      return;
    }
    const fleetId = this.fleetId;
    this.spinnerService.show();
    this.isRemoving = true;
    // First request: classification only (no detach)
    this.basicInfoService.detachVehiclesFromFleet(fleetId, numbers, false).subscribe((res: any) => {
      this.spinnerService.hide();
      this.isRemoving = false;
      const responseData = res && res.data ? res.data : {};
      const attached = Array.isArray(responseData.attached) ? responseData.attached : [];
      const notAttached = Array.isArray(responseData.notAttached) ? responseData.notAttached : [];
      // If both attached and notAttached are present, show the special cannot-remove dialog (previous behaviour)
      if ((attached && attached.length > 0) && (notAttached && notAttached.length > 0)) {
        this.showDetachConfirmDialog(attached, notAttached);
        return;
      }
      if ((attached && attached.length > 0) && (!notAttached || notAttached.length === 0)) {
        // Only attached vehicles; show the cannot-remove dialog with only Cancel (no primary action)
        this.showDetachConfirmDialog(attached, notAttached);
        return;
      }
      // Otherwise show the general confirmation dialog (works for only-attached and only-notAttached cases)
      this.showRemoveConfirmDialog(numbers, attached, notAttached);
    }, error => {
      this.spinnerService.hide();
      this.isRemoving = false;
      const errorMessage = error && error.error && error.error.message || 'Failed to remove vehicles from fleet';
      this.toastMessage.openSnackBarError(errorMessage);
    });
  }

  private showRemoveConfirmDialog(originalSelection: string[], attached: string[], notAttached: string[]) {
    const listToShow = (attached && attached.length > 0) ? attached : originalSelection;
    const title = `Are you sure you want to remove ${listToShow.join(', ')} from fleet?`;
    const disablePrimary = (attached && attached.length > 0 && (!notAttached || notAttached.length === 0));
    const dialogRef = this.dialog.open(PopUpMessageComponent, {
      width: '600px',
      data: {
        options: [],
        title,
        message: 'Once removed you will have to re-upload vehicle details',
        reason: 'confirmDetach',
        buttonText: 'Remove',
        cancelText: 'Cancel',
        stackedButtons: false,
        disablePrimary,
        styles: {
          title: 'font-size-20 margin-bottom-20',
          actionClass: 'deactivate-merchant-popup',
          message: 'margin-top-8 margin-bottom-0 color-grey'
        },
      },
    });

    dialogRef.afterClosed().subscribe((proceed: boolean) => {
      if (!proceed) { return; }
      // On confirm: call API with detach=true and only notAttached per requirement
      const vehicleNumbersToDetach = Array.isArray(notAttached) ? notAttached : [];
      if (vehicleNumbersToDetach.length === 0) {
        // Show cannot remove dialog again if nothing is removable
        if (attached && attached.length > 0) {
          this.showDetachConfirmDialog(attached, notAttached);
        }
        return;
      }
      this.isRemoving = true;
      this.spinnerService.show();
      this.basicInfoService.detachVehiclesFromFleet(this.fleetId, vehicleNumbersToDetach, true).subscribe((res2: any) => {
        this.spinnerService.hide();
        this.isRemoving = false;
        const responseData2 = res2 && res2.data ? res2.data : {};
        const attached2 = Array.isArray(responseData2.attached) ? responseData2.attached : [];
        const notAttached2 = Array.isArray(responseData2.notAttached) ? responseData2.notAttached : [];
        if (!attached2 || attached2.length === 0) {
          this.showSuccessPopup('Vehicle Removed from fleet');
          this.fetchFleetVehicles();
          this.selectedNumbers.clear();
        } else {
          // Still some attached - show cannot remove dialog again
          this.showDetachConfirmDialog(attached2, notAttached2);
        }
      }, err => {
        this.spinnerService.hide();
        this.isRemoving = false;
        const errorMessage = err && err.error && err.error.message || 'Failed to remove vehicles from fleet';
        this.toastMessage.openSnackBarError(errorMessage);
      });
    });
  }

  private showDetachConfirmDialog(attached: string[], notAttached: string[]) {
    const attachedMsg = attached.join(', ');
    const notAttachedMsg = notAttached.join(', ');
    const dialogRef = this.dialog.open(PopUpMessageComponent, {
      width: '550px',
      data: {
        options: [],
        title: `Cannot remove ${attachedMsg} as captain is ON-DUTY`,
        message: notAttached && notAttached.length > 0 ? `You can remove ${notAttachedMsg} from fleet` : 'No other vehicles can be removed',
        reason: 'detachOtherVehicles',
        buttonText: 'Remove Other Vehicles',
        cancelText: 'Cancel',
        stackedButtons: true,
        hidePrimary: !notAttached || notAttached.length === 0,
        styles: {
          title: 'font-size-20 margin-bottom-30',
          actionClass: 'doc-details-change-confirm',
          message: 'margin-top-8 margin-bottom-20 color-grey'
        },
      },
    });

    dialogRef.afterClosed().subscribe((proceed: boolean) => {
      if (proceed && notAttached && notAttached.length > 0) {
        // Call API again with notAttached numbers only
        this.isRemoving = true;
        this.spinnerService.show();
        this.basicInfoService.detachVehiclesFromFleet(this.fleetId, notAttached, true).subscribe((res: any) => {
          this.spinnerService.hide();
          this.isRemoving = false;
          const responseData = res && res.data && res.data.data ? res.data.data : {};
          const attached2 = Array.isArray(responseData.attached) ? responseData.attached : [];
          if (!attached2 || attached2.length === 0) {
            this.showSuccessPopup('Vehicle Removed from fleet');
            this.fetchFleetVehicles();
            this.selectedNumbers.clear();
          } else {
            // Edge: still attached remaining (unlikely); recurse to show again
            this.showDetachConfirmDialog(attached2, responseData.notAttached || []);
          }
        }, err => {
          this.spinnerService.hide();
          this.isRemoving = false;
          const errorMessage = err && err.error && err.error.message || 'Failed to remove vehicles from fleet';
          this.toastMessage.openSnackBarError(errorMessage);
        });
      }
    });
  }

  private showSuccessPopup(message: string) {
    const dialogRef = this.dialog.open(PopUpMessageComponent, {
      width: '420px',
      data: {
        type: 'success',
        options: [],
        title: message,
        styles: { title: 'font-size-20 margin-bottom-10 text-center' },
        buttonText: 'Close',
        cancelText: null,
      }
    });
    setTimeout(() => dialogRef.close(), 1500);
  }
}
